import { PlatformAnnouncements, ProductAnnouncement, railsCsrfFetch } from "@planningcenter/topbar"
import { object, string } from "prop-types"

const RegistrationsAnnouncements = ({
  platformAnnouncements,
  productAnnouncement,
  railsEnv: env
}) => {
  const isPhoenix = true

  return (
    <>
      <PlatformAnnouncements
        data={platformAnnouncements}
        env={env}
        configuredFetch={railsCsrfFetch}
        isPhoenix={isPhoenix}
      />

      {productAnnouncement && (
        <ProductAnnouncement
          html={productAnnouncement.message}
          onClick={() =>
            fetch(`/product_announcement`, {
              method: "DELETE",
              headers: {
                "X-CSRF-Token": $.rails.csrfToken()
              }
            })
          }
          isPhoenix={isPhoenix}
        />
      )}
    </>
  )
}

RegistrationsAnnouncements.propTypes = {
  platformAnnouncements: object.isRequired,
  productAnnouncement: object,
  railsEnv: string.isRequired
}

export default RegistrationsAnnouncements
